import React from 'react';
import Stack, { type StackProps } from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FormatAPIDate from '../shared/format-api-date';

interface Props extends StackProps {
  readonly createdAt: string;
  readonly createdBy: {
    readonly email: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly resourceId: string;
  };
  readonly updatedAt?: string;
  readonly updatedBy?: {
    readonly email: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly resourceId: string;
  };
}

export default function Metadata({
  createdBy, updatedBy, createdAt, updatedAt, ...props
}: Props) {
  return (
    <Stack {...props}>
      <Typography variant="caption">
        Created by
        {' '}
        <b>
          {createdBy.firstName}
          {' '}
          {createdBy.lastName}
        </b>
        {' '}
        on
        {' '}
        {FormatAPIDate(createdAt, { dateOnly: true })}
      </Typography>
      {updatedBy && (
        <Typography variant="caption">
          Last edited
          {' '}
          {FormatAPIDate(updatedAt)}
          {' '}
          by
          {' '}
          <b>
            {updatedBy.firstName}
            {' '}
            {updatedBy.lastName}
          </b>
        </Typography>
      )}
    </Stack>
  );
}
